import { Component } from '@angular/core';
import { ProtocolEntryDto } from '@interfaces/interfaces';
import { ActiveParticipantService } from '@app/services/participants/active-participant.service';
import { combineLatest, Observable } from 'rxjs';
import { ProtocolRestService } from '@app/services/rest/protocol-rest.service';
import { startWith, switchMap } from 'rxjs/operators';
import { ProjectService } from '@app/services/project/project.service';

@Component({
	selector: 'app-participant-timeline',
	templateUrl: './participant-timeline.component.html',
	styleUrls: ['./participant-timeline.component.scss'],
})
export class ParticipantTimelineComponent {
	
	public readonly entries$: Observable<ProtocolEntryDto[] | null>;
	
	constructor(projectService: ProjectService, activeParticipantService: ActiveParticipantService, protocolRestService: ProtocolRestService) {
		this.entries$ = combineLatest([
			projectService.activeProject$,
			activeParticipantService.participant$,
		]).pipe(
			switchMap(([activeProject, activeParticipant]) =>
				protocolRestService.getProtocolEntries$(activeProject.project_id, { participantids: [activeParticipant.id] }),
			),
		).pipe(
			startWith<ProtocolEntryDto[], null>(null),
		);
	}
}
